import { Link } from "react-router-dom";
import {
  LinkedIn,
  Facebook,
  Instagram,
  Twitter,
  GitHub,
} from "@mui/icons-material/";
import { useState } from "react";

function Footer() {
  const [email, setEmail] = useState<any>();
  const [error, setError] = useState("");
  const date = new Date();
  const [message, setMessate] = useState("");
  const year = date.getFullYear();
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setError("");
    setMessate("");

    if (!email) {
      setError("Email is required");
      return;
    }

    if (
      !/\S+@\S+\.\S+/.test(email) ||
      !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
    ) {
      setError("Email is invalid");
      return;
    }
    try {
      const dataEmail: any = {
        email,
      };
      const response = await fetch(
        // "https://afternoon-lowlands-25130.herokuapp.com/newsletter"
        // "https://newsletter-subscription-email-production.up.railway.app/newsletter",
        // "https://frightened-hat-mite.cyclic.app/newsletter",
        "https://sub-newsletter.onrender.com/newsletter",
        {
          method: "POST",
          body: JSON.stringify(dataEmail),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      setEmail({ data });
      setMessate("Thank you for subscribing!");
    } catch (err) {
      console.log(err);
      setError("An error occured. Please try  again");
    }

    setEmail("");
  };

  return (
    <footer
      className="bg-dark text-center text-white"
      style={{ position: "relative", zIndex: 1 }}
    >
      <div className="container p-4">
        <section className="mb-4">
          <a
            target="_blank"
            className="btn btn-outline-light btn-floating m-1"
            href="https://facebook.com/drugstoc"
            role="button"
            rel="noreferrer"
          >
            <Facebook />
          </a>

          <a
            target="_blank"
            className="btn btn-outline-light btn-floating m-1"
            href="https://twitter.com/drugstoc"
            role="button"
            rel="noreferrer"
          >
            <Twitter />
          </a>

          <a
            target="_blank"
            className="btn btn-outline-light btn-floating m-1"
            href="https://instagram.com/drugstoc"
            role="button"
            rel="noreferrer"
          >
            <Instagram />
          </a>

          <a
            target="_blank"
            className="btn btn-outline-light btn-floating m-1"
            href="https://linkedin.com/company/drugstoc/"
            role="button"
            rel="noreferrer"
          >
            <LinkedIn />
          </a>

          <a
            target="_blank"
            className="btn btn-outline-light btn-floating m-1"
            href="https://github.com/drugstoc"
            role="button"
            rel="noreferrer"
          >
            <GitHub />
          </a>
        </section>

        <section className="">
          <form onSubmit={handleSubmit}>
            <div className="row d-flex justify-content-center">
              <div className="col-auto">
                <p className="pt-2">
                  <strong>Sign up for our newsletter</strong>
                </p>
              </div>

              <div className="col-md-5 col-12">
                <div className="form-outline form-white mb-4">
                  {message && (
                    <p
                      style={{
                        color: "green",
                        backgroundColor: "white",
                        border: "1px solid white",
                        borderRadius: 4,
                      }}
                    >
                      {message}
                    </p>
                  )}

                  {error && (
                    <p
                      style={{
                        color: "red",
                        backgroundColor: "white",
                        border: "1px solid white",
                        borderRadius: 4,
                      }}
                    >
                      {error}
                    </p>
                  )}

                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    // name="mc-embedded-subscribe-form"
                    id="email"
                    className="form-control"
                  />
                  <label className="form-label" htmlFor="email">
                    Email address
                  </label>
                </div>
              </div>

              <div className="col-auto">
                <button type="submit" className="btn btn-outline-light mb-4">
                  Subscribe
                </button>
              </div>
            </div>
          </form>
        </section>

        <section className="mb-4">
          <p>
            At DrugStoc, we combine the use of unmatched technology, supply
            chain innovation, financial solutions, and product knowledge to
            unlock access to medications in emerging Economies.
          </p>
        </section>
      </div>

      <div
        className="text-center p-3"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
      >
        &copy; {year} Copyright:{" "}
        <Link className="text-white" to="/">
          App.DrugStoc.com
        </Link>
      </div>
    </footer>
  );
}

export default Footer;
